import { render, staticRenderFns } from "./TMap.vue?vue&type=template&id=2adedf3f&scoped=true"
import script from "./TMap.vue?vue&type=script&lang=js"
export * from "./TMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adedf3f",
  null
  
)

export default component.exports